import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  // Get transfer list
  getTransferList: async ({ commit }, payload) => {
    const { limit, page, order, search } = payload
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get('/product/transfers', {
        params: {
          limit,
          page,
          order,
          search
        }
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'transfers',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // sync transfer list
  syncList: async ({ commit, dispatch }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      await axios.post('/transfer/sync-metrc-transfer', payload)

      // get new transfer list
      dispatch('getTransferList', { limit: 10, page: 1 })

      return true
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get transfer by id
  getTransferById: async (_, id) => {
    try {
      const res = await axios.get(`/product/transfer/${id}`)

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // add new transfer
  addTransfer: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.post('/product/bulk-insert', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // complete transfer
  completeTransfer: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.post(`transfer/${id}/transfer-complete`, data)

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // delete transfer
  deleteTransferRecord: async ({ commit }, id) => {
    // loader start
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      // delete request
      const res = await axios.delete(`/transfer/${id}`)

      // loader off
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      // loader off
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // error message
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get transfer details by id
  getViewTransferDetailsById: async (_, id) => {
    try {
      const res = await axios.get(`/product/${id}/get-tansfer-product`)

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  deleteTransfer: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.delete(`/product/${id}/delete-transfer`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  }
}
